// Editable section bodies are stored separately from the existing introduction.
// Markdown headings give every selection an offset in a single persisted field.
export function defaultBody(term) {
  let titles;
  if(['model-context-protocol-mcp','agent2agent-a2a'].includes(term.id)) titles=['背景','設計與架構','核心概念','應用與採用','安全性'];
  else titles={
    'AI 代理':['運作原理','架構與組成','應用','限制與風險'],
    '上下文與提示':['原理與方法','應用','限制與風險'],
    '訓練與推論':['原理','方法與流程','應用','限制與評估'],
    '開發與產業':['背景','方法與實務','應用','影響與爭議'],
    'AI 基礎與資料':['原理','發展歷史','應用','限制'],
    '維基與開放知識':['歷史','特色與運作','應用','相關計畫'],
  }[term.category]||['原理','應用','限制'];
  return titles.map(title=>`## ${title}\n`).join('\n');
}
export function parseBody(text='') {
  const wiki=/^==[^=].*==\s*$/m.test(text);
  const matches=[...text.matchAll(wiki?/^== ([^\n]*?) ==[ \t]*\n?/gm:/^## ([^\n]*)\n?/gm)];
  if(!matches.length)return text?[{title:'內文',text,start:0,titleStart:null}]:[];
  const sections=[];
  if(matches[0].index>0&&text.slice(0,matches[0].index).trim())sections.push({title:'內文',text:text.slice(0,matches[0].index),start:0,titleStart:null});
  for(let i=0;i<matches.length;i++){
    const m=matches[i],start=m.index+m[0].length,end=matches[i+1]?.index??text.length;
    sections.push({title:m[1],text:text.slice(start,end).replace(/\n{1,2}$/,''),start,titleStart:m.index+3});
  }
  return sections;
}
export function serializeSections(sections){return sections.map(s=>`## ${s.title.replaceAll('\n',' ')}\n${s.text}\n\n`).join('');}
